import React, { useState } from "react"
import { ModalWrap, Expand } from "./styles/ImageModal.styled"
import Modal from "."
import { ContentfulImage } from "@components/ContentfulImage"
import maximize from "../../../static/icons/maximize.svg"

const ImageModal = ({ reference }) => {
  const [play, setPlay] = useState()

  return (
    <ModalWrap>
      <Expand onClick={() => setPlay(true)} src={maximize} alt="icon" />
      <ContentfulImage imageData={reference} showCaption={true} />
      <Modal show={play} onClose={() => setPlay(false)} reference={reference} />
    </ModalWrap>
  )
}

export default ImageModal
